<template>
  <div class="modal-card is-full-screen">
    <!-- eslint-disable vue/no-v-html -->
    <b-loading :isFullPage="false" :active="isLoading" />
    <header class="modal-card-head pb-0">
      <div class="modal-card-title">
        <strong class="is-size-5">
          {{ App.ProcessViewer.MODAL_1.CHANGED_VIEW }}
        </strong>
      </div>
      <div class="close-button cursor-pointer" @click.stop="close">
        <b-icon icon="close" />
      </div>
    </header>

    <div class="modal-content-container has-text-centered has-text-color-7">
      <div class="has-text-center info-container">
        {{ App.ProcessViewer.MODAL_1.INFO_TEXT }}
        <div class="has-text-color-5">
          {{ App.ProcessViewer.MODAL_1.ACTION_OPTIONS }}
        </div>
        <div class="options-container">
          <b-icon
            icon="plus-box-outline"
            :type="isContrast ? 'is-white' : 'is-green-lawn'"
            size="is-large"
          />
          <p class="has-text-justified" v-html="getHtmlExpandInfo" />
        </div>
        <div class="options-container">
          <b-icon
            icon="file-document"
            :type="isContrast ? 'is-white' : 'is-green-lawn'"
            size="is-large"
          />
          <p
            class="has-text-justified"
            v-html="App.ProcessViewer.MODAL_1.HTML_INFO_ESPECIFIC"
          />
        </div>
        <div class="options-container">
          <b-icon
            icon="download"
            :type="isContrast ? 'is-white' : 'is-green-lawn'"
            size="is-large"
          />
          <p
            class="has-text-justified"
            v-html="App.ProcessViewer.MODAL_1.HTML_INFO_DOWNLOAD"
          />
        </div>
      </div>
    </div>

    <div class="is-flex is-justify-content-center mb-20">
      <b-button
        tag="a"
        href="https://suite.seplag.ce.gov.br/?p=202"
        target="_blank"
        :type="isContrast ? 'is-white' : 'is-green-lawn'"
      >
        {{ General.LEARN_MORE }}
      </b-button>
    </div>
  </div>
</template>

<script>
import { App, General } from "@/utils/constants";
import { mapGetters } from "vuex";

export default {
  name: "ModalProcessView",

  data() {
    return {
      App,
      General,
      isLoading: false
    };
  },

  computed: {
    ...mapGetters({ isContrast: "isContrast" }),

    getInlineIconWithColor() {
      const color = this.isContrast
        ? "has-text-color-white"
        : "has-text-color-blue-oil";
      return App.ProcessViewer.MODAL_1.HTML_INLINE_ICON.replace(
        "(COLOR)",
        color
      );
    },

    getHtmlExpandInfo() {
      return App.ProcessViewer.MODAL_1.HTML_INFO_EXPAND.replace(
        "(ICON)",
        this.getInlineIconWithColor
      );
    }
  },

  methods: {
    close() {
      this.$parent.close();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables";

.modal-card {
  display: flex;
  justify-content: space-between;
  min-height: 430px;
  width: 800px;
  background-color: $color-1;

  @media only screen and (max-width: $tablet) {
    width: 100%;
  }
}

.modal-card-head {
  display: flex;
  align-items: flex-start;
}

.modal-card-title {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
}

.modal-content-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 85%;
  margin: 20px auto;
  gap: 10px;
}

.info-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.options-container {
  display: flex;
  border: 1px solid $color-3;
  padding: 10px 30px;
  gap: 20px;
}

.custom-button {
  max-width: 150px;
}
</style>
